<template>
  <label class="text-left text-sm font-medium mb-1 flex"><slot /></label>
</template>

<script>
export default {

}
</script>

<style>

</style>